import { EmployeeStatus } from '@westondev/tableturn-core';

export const VALUE_TO_EMPLOYEE_STATUS: Record<number, EmployeeStatus | ''> = {
  2: EmployeeStatus.ClockIn,
  3: EmployeeStatus.ClockOut,
};

export const EMPLOYEE_STATUS_TO_VALUE: Record<EmployeeStatus, number> = {
  [EmployeeStatus.ClockIn]: 2,
  [EmployeeStatus.ClockOut]: 3,
};
